module.exports = __webpack_public_path__ + "img/loading.91762b2a.svg";